import { Kooperation } from 'fobclient/lib/entity'
import AbstractPerson from './AbstractPerson'
import ExterneOrganisation from './ExterneOrganisation'

import FieldsGeneric from './FieldsGeneric'
let Fields = FieldsGeneric('Kooperation')

export default {
  label: 'Kooperation',
  route: 'kooperation',
  className: 'kooperation',
  class: Kooperation,
  fields: [
    Fields.organisationseinheit,
    Fields.relevantFuerWeitere,
    Fields.weitereOrganisationseinheiten,
    Fields.String('titelKooperation'),
    Fields.Text('kurzbeschreibung', 6000),
    Fields.MultiReference(
      'ansprechpartner',
      'user',
      AbstractPerson
    ),
    Fields.Date('beginn'),
    Fields.Boolean('endeGeplant'),
    {
      ...Fields.Date('ende'),
      view (data, user) {
        return data.endeGeplant === true
      }
    },
    { ...Fields.Label('kooperationsarten'), inPublicView: false },
    { ...Fields.Boolean('gemeinsameThemen'), narrow: true, inPublicView: false },
    { ...Fields.Boolean('gegenseiteHilfe'), narrow: true, inPublicView: false },
    { ...Fields.Boolean('gastaufenthalte'), narrow: true, inPublicView: false },
    { ...Fields.Boolean('gemeinsameTagungen'), narrow: true, inPublicView: false },
    { ...Fields.Boolean('gemeinsamePublikationen'), narrow: true, inPublicView: false },
    { ...Fields.Boolean('doktorandenProgramm'), narrow: true, inPublicView: false },
    { ...Fields.Boolean('andereKooperation'), narrow: true, inPublicView: false },
    {
      ...Fields.Text('kooperationsartFreitext', 6000),
      view (data, user) {
        return data.andereKooperation === true
      }
    },

    Fields.MultiReference(
      'beteiligtePersonen',
      'user',
      AbstractPerson
    ),
    Fields.SimpleMultiReference(
      'beteiligteOrganisationen',
      'sitemap',
      ExterneOrganisation
    )
  ]
}



// WEBPACK FOOTER //
// ./src/schema/Kooperation.js